import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'CRED_LIST_GET_ALL',
  GET_ALL_SUCCESS: 'CRED_LIST_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'CRED_LIST_GET_ALL_FAILURE',
};

export const getAll = actions.getAll(
  query => `${BASE_URL}/demo/cred/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);
